import { Message } from "element-ui";

export function loadScript( url ){
    return new Promise((resolve, reject) => {
        if(_checkScriptLoaded(url)){
            resolve('success')
            return
        }
        var script = document.createElement('script')
        script.type = 'text/javascript';
        if(script.readyState){
            script.onreadystatechange = function(){
                if( script.readyState == 'loaded' || script.readyState == 'complete' ){
                    script.onreadystatechange = null;
                    resolve('success');
                }
            };
        }else{
            script.onload = function(){
                resolve('success');
            };
            script.onerror = function() {
                resolve('fail');
                Message({
                    type: 'warning',
                    message: '插件加载失败，请检查您的网络。'
                })
            }
        }
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    })
    
}

export function loadBaiduJs(ak) {
    return new Promise((resolve, reject) => {
        if (typeof BMap !== 'undefined') {
            resolve(BMap)
            return true
        }
        window.onBMapCallback = function () {
            resolve(BMap)
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://api.map.baidu.com/api?v=2.0&ak=' + ak + '&callback=onBMapCallback'
        script.onerror = reject
        document.head.appendChild(script)
    })
}

function _checkScriptLoaded(url){
    const script = document.querySelector(`head > script[src="${url}"]`)
    if(script){
        return true
    }else{
        return false
    }
}
export function loadCSS(text) {
    const style = document.createElement('style')
    style.type = "text/css"
    style.innerHTML = text
    document.head.appendChild(style)
}


// WEBPACK FOOTER //
// ./src/lib/util/load-dynamic.js